import api from './api';

/**
 * The paid AI tools (backend: /api/sohoz-tools). One credit a run, taken before
 * the AI call and never given back — a failed run costs the same as a good one.
 * `error.code` is what the caller acts on: INSUFFICIENT_CREDITS opens the top-up
 * modal, NO_PHOTOS_FOUND / NO_TEXT_FOUND are ordinary messages.
 *
 * Vision calls on a full-size photo are slow; the timeouts are generous.
 */
const sohozToolsService = {
    // What one run costs the active office space's owner — for the tool's badge.
    getCost: (params = {}) => api.get('/api/sohoz-tools/cost', { params }),

    // Find every printed photograph inside one picture and cut each one out.
    imageSplit: (payload) => api.post('/api/sohoz-tools/image-split', payload, { timeout: 180000 }),

    // Read the text — printed or handwritten — out of one picture.
    imageToText: (payload) => api.post('/api/sohoz-tools/image-to-text', payload, { timeout: 180000 }),
};

export default sohozToolsService;
